module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_2.6eb13d6b.png";